"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGoogleButton = void 0;
const isGoogleButton = (selectBy) => selectBy?.includes('btn');
exports.isGoogleButton = isGoogleButton;
